import React from 'react';
import { Box, Typography, Chip } from '@material-ui/core';
import CustomMenu from '../../../../components/management/menu';

export const formatLastRefreshedTime = (timestamp) => {
  if (!timestamp) return '';
  const options = { hour: 'numeric', minute: '2-digit', hour12: true };
  return `Last Refreshed ${timestamp.toLocaleTimeString('en-US', options)}`;
};

export const mapLearningPlansToRows = (learningPlans, actions = {}, classes = {}) => {
  
  if (!Array.isArray(learningPlans)) {
    console.error('Expected learningPlans to be an array, got:', learningPlans);
    return [];
  }
  
  const { handleDetailsClick, handleGamificationClick, handleViewProgressClick } = actions;
  
  return learningPlans.map(plan => {
    const options = [
      {
        title: 'Details',
        onClick: () => handleDetailsClick(plan),
      },
      {
        title: 'Gamification',
        onClick: () => handleGamificationClick(plan.key)
      },
      {
        title: 'View Progress',
        onClick: () => handleViewProgressClick(plan.key)
      },
    ];

    const statusDisplay = plan.status ? 'Active' : 'Inactive';


    return {
      isSelected: false,
      rowData: {
        id: plan.id,
        learningPlan: () => (
          <Box>
            <Typography variant="body1" className={classes.learningPlanName}>
              {plan.title}
            </Typography>
            <Typography variant="caption" className={classes.learningPlanKey}>
              Key: {plan.key}
            </Typography>
          </Box>
        ),
        learningPlanKey: plan.key,
        status: () => {
          const isActive = statusDisplay === 'Active';
          return (
            <Chip
              label={statusDisplay}
              className={`${classes.statusChip} ${isActive ? classes.statusChipActive : classes.statusChipInactive}`}
            />
          );
        },
        locations: '',
        pillars: `${plan.totalPillars} Pillars`,
        enrolledLearners: '0',
        actions: () => <CustomMenu options={options} />
      },
    };
  });
};

export const countRules = (criteria) => {
  if (!criteria || !criteria?.rules) {
    return 0;
  }
  return criteria.rules.length;
};

